/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../../../components/Modal';
import { WalletScreens } from '../../constants';
import SelectCurrency from './SelectCurrency';

const AddAccountModal = ({ hide, allowedCurrencies, exitedWallets }) => {
  const [currentScreen, setCurrentScreen] = useState(WalletScreens.SELECT_CURRENCY);

  const screens = useMemo(
    () => [
      {
        screen: WalletScreens.SELECT_CURRENCY,
        component: (
          <SelectCurrency
            allowedCurrencies={allowedCurrencies}
            exitedWallets={exitedWallets}
            onCloseModal={hide}
            openScreen={setCurrentScreen}
          />
        ),
      },
    ],
    []
  );

  const SelectedComponent = useMemo(
    () => screens.find((item) => item.screen === currentScreen).component,
    [screens, currentScreen]
  );

  return (
    <ModalRoot>
      <Modal>
        <ModalHeader>
          <i
            onClick={(e) => {
              e.target.closest('html').classList.remove('overflow-hidden');
              hide();
            }}
            onKeyDown={hide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>{SelectedComponent}</ModalBody>
      </Modal>
    </ModalRoot>
  );
};

AddAccountModal.propTypes = {
  hide: PropTypes.func,
  allowedCurrencies: PropTypes.object.isRequired,
  exitedWallets: PropTypes.arrayOf(PropTypes.string).isRequired,
};
AddAccountModal.defaultProps = {
  hide: null,
};

export default AddAccountModal;
